import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=fa15c852&scoped=true&"
import script from "./homePage.vue?vue&type=script&lang=js&"
export * from "./homePage.vue?vue&type=script&lang=js&"
import style0 from "./homePage.vue?vue&type=style&index=0&id=fa15c852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa15c852",
  null
  
)

export default component.exports